import { z } from 'zod';
import { zObject, zSchema } from '../util/zod';

export type jObjectBase = {
    id: number;
    mainType: string;
    type: string;
    uri: string;
    dateCreation?: string | undefined;
    dateModified?: string | null | undefined;
};
export const jObjectBaseSchema = zObject<jObjectBase>({
    id: z.number(),
    mainType: z.string(),
    type: z.string(),
    uri: z.string(),
    dateCreation: z.string().optional(),
    dateModified: z.string().nullable().optional(),
});

export type jObjectLittle = jObjectBase & {
    title: string;
    _url: string;
};
const jObjectLittleSchemaTmp = jObjectBaseSchema.extend({
    title: z.string(),
    _url: z.string(),
});
export const jObjectLittleSchema = zSchema<jObjectLittle, typeof jObjectLittleSchemaTmp.shape>(jObjectLittleSchemaTmp);

export const validateIsFormatObjectLittle = (object: object): object is jObjectLittle => {
    return jObjectLittleSchema.safeParse(object).success;
};
